var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"title":"温馨提示","customClass":"customWidth","visible":_vm.visible},on:{"update:visible":function($event){_vm.visible=$event},"close":_vm.closeDialog}},[_c('div',{staticClass:"pop-centers-list"},[_c('div',{staticClass:"code"},[_c('p',[_vm._v("此素材网暂时不支持自动下载")]),_c('p',[_vm._v("请联系客服")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }